import React, { useContext } from "react";
import ListFilter from "Components/listFilter/ListFilter";
import CustomerSelect from "Components/customerSelect/CustomerSelect";
import ButtonIcon from "Components/buttonIcon/ButtonIcon";
import PaginationFilter from "Components/paginationFilter/PaginationFilter";
import Pager from "Components/pager/Pager";
import PaginationShow from "Components/paginationShow/PaginationShow";
import { refresh, gridLayout, listLayout } from "Icons";
import cx from "classnames";
import { MediaQueriesContext } from "@/App";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import IconsSwitch from "Components/iconsSwitch/IconsSwitch";
import qs from "query-string";

const ListControls = ({
  className,
  paginationInfo,
  location,
  isLoading,
  refreshList,
  totals,
  listFilters,
  listFilterParam,
  listFilterLegends,
  showListFilter = true,
  showPager = true,
  showRefreshButton = true,
  showPaginationFilter = true,
  showPagination = true,
  showCustomerSelection = false,
  paginationShowOptions,
  shortenPagesOver,
  selectedListLayout,
  onListLayoutChange,
}) => {
  const { isMediaMobile, isMediaSM } = useContext(MediaQueriesContext);
  const { search } = useLocation();
  const history = useHistory();

  const query = qs.parse(search);

  const onCustomerSelection = (customer) => {
    if (customer) {
      history.push({
        pathname: location.pathname,
        search: qs.stringify({
          ...qs.parse(location.search),
          customer_code: customer.value,
          page: 1,
          per: 25,
        }),
        state: { prevPathname: location.pathname },
      });
    } else {
      const search = qs.parse(location.search);
      delete search["customer_code"];

      history.push({
        pathname: location.pathname,
        search: qs.stringify({
          ...search,
          page: 1,
          per: 25,
        }),
        state: { prevPathname: location.pathname },
      });
    }
  };

  return isMediaMobile ? (
    <div className="flex flex-col w-full gap-4">
      {showPaginationFilter && (
        <PaginationFilter
          className="sm:min-w-[11rem] sm:max-w-[15rem]"
          url={location.pathname}
          currentQuery={query.query}
          paginationFilter={query}
        />
      )}

      <div className="flex justify-between w-full">
        {showListFilter && (
          <ListFilter
            className="w-24 sm:w-44"
            values={listFilters}
            active={listFilterParam ? query[listFilterParam] : query.status}
            location={location}
            paginationInfo={paginationInfo}
            legendIcons={listFilterLegends}
            param={listFilterParam || "status"}
            url={location.pathname}
            totals={paginationInfo.totals || totals}
          />
        )}

        <div className="flex gap-4">
          {showRefreshButton && (
            <ButtonIcon
              className={cx("w-8", { ["isRefreshing"]: isLoading })}
              icon={refresh}
              onClick={isLoading ? () => {} : refreshList}
            />
          )}

          <IconsSwitch
            firstIcon={listLayout}
            secondIcon={gridLayout}
            selectedIndex={selectedListLayout}
            onChange={onListLayoutChange}
          />

          {showPager && (
            <Pager
              history={history}
              paginationInfo={{ ...query, ...paginationInfo }}
              url={location.pathname}
              shortenPagesOver={shortenPagesOver}
            />
          )}
        </div>
      </div>
    </div>
  ) : (
    <div className={cx(className, "flex")}>
      <div className="flex flex-1 gap-4">
        {showListFilter && (
          <ListFilter
            className="w-24 sm:w-44"
            values={listFilters}
            active={listFilterParam ? query[listFilterParam] : query.status}
            location={location}
            paginationInfo={paginationInfo}
            legendIcons={listFilterLegends}
            param={listFilterParam || "status"}
            url={location.pathname}
            totals={paginationInfo.totals || totals}
          />
        )}

        {showPaginationFilter && (
          <PaginationFilter
            className="sm:min-w-[11rem] sm:max-w-[15rem]"
            url={location.pathname}
            currentQuery={query.query}
            paginationFilter={query}
          />
        )}

        {!isMediaSM && showCustomerSelection && (
          <CustomerSelect
            withoutDomainCounter
            className="w-full md:min-w-[9rem] md:max-w-[15rem]"
            initialValue={query.customer_code}
            onChange={onCustomerSelection}
            noLabel
          />
        )}
      </div>

      <div className="flex gap-4">
        {showRefreshButton && (
          <ButtonIcon
            className={cx("w-8", { ["isRefreshing"]: isLoading })}
            icon={refresh}
            onClick={isLoading ? () => {} : refreshList}
          />
        )}

        <IconsSwitch
          firstIcon={listLayout}
          secondIcon={gridLayout}
          selectedIndex={selectedListLayout}
          onChange={onListLayoutChange}
        />

        {showPagination && (
          <PaginationShow className="w-14" options={paginationShowOptions} history={history} location={location} />
        )}

        {showPager && (
          <Pager
            history={history}
            paginationInfo={{ ...query, ...paginationInfo }}
            url={location.pathname}
            shortenPagesOver={shortenPagesOver}
          />
        )}
      </div>
    </div>
  );
};

export default ListControls;
